import React from 'react';
import queryString from 'query-string';
import { Breadcrumb, BreadcrumbItem } from "react-bootstrap";
import { connect } from 'react-redux';
import { LinkContainer } from "react-router-bootstrap";
import { branch, compose, lifecycle, renderComponent, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../../constants';
import { getDefaultProgressLabel } from '../../../../services';
import { businessActions, businessSelector, businessTeamsWithStatsSelector, businessTrainingPlanSelector } from '../../../../state/modules/business';
import { userAfslSelector } from '../../../../state/modules/user';
import Loading from '../../loading';
import teamProgressReport from '../../shared/team-progress-report';

const reportBreadCrumb =
  <Breadcrumb>
    <LinkContainer to={routes.app.teams.root}>
      <BreadcrumbItem>
        Teams
            </BreadcrumbItem>
    </LinkContainer>
    <BreadcrumbItem active>
      Team Progress Report
    </BreadcrumbItem>
  </Breadcrumb>

const mapStateToProps = (state) => ({
  afsLicence: userAfslSelector(state),
  business: businessSelector(state),
  trainingPlans: businessTrainingPlanSelector(state),
  defaultProgressLabel: getDefaultProgressLabel(state.user.profile),
  businessTeamsWithStats: businessTeamsWithStatsSelector(state),
  isFetchingTeamsWithStats: state.business.isFetchingTeamsWithStats,
});

const mapDispatchToProps = (dispatch) => ({
  getTeamsWithStats: bindActionCreators(businessActions.business.team.getTeamsWithStats, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ business }) => !business,
    renderComponent(Loading)
  ),
  withProps(() => {
    const parsed = queryString.parse(window.location.search);
    return ({
      showCpdPeriodSelect: true,
      yearsFromNow: Math.min(parseInt(parsed.yearsFromNow, 10) || 0, 0),
    })
  }),
  lifecycle({
    componentDidMount() {
      const {
        business,
        getTeamsWithStats,
        yearsFromNow,
      } = this.props;

      getTeamsWithStats(business.id, { yearsFromNow })
    },
  }),
  branch(
    ({ businessTeamsWithStats, isFetchingTeamsWithStats }) => !businessTeamsWithStats || isFetchingTeamsWithStats,
    renderComponent(Loading)
  ),
  withProps(() => ({
    reportBreadCrumb: reportBreadCrumb,
    downloadBusinessActivityFor: 'businessWithYearsOffset'
  }))
)(teamProgressReport)


// WEBPACK FOOTER //
// ./src/containers/pages/app/teams/team-progress-report.js